var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center text-nowrap text-uppercase",class:{active: _vm.isActive, 'not-active': !_vm.isActive}},[_c('div',{staticClass:"px-2 py-1"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }